import { getFolders, zmTask } from '@/api/local-material'

export default {
    components: {},
    props: {
        showZmForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ titles: [] })
        }
    },
    created() {
        this.actionName = '转码'
     },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            loading: false,
            actionName: '操作',
            rules: {
                pid: [{ required: true, message: '请选择转码后的目录', trigger: 'change' }],
            },
            titles: [],
            show: false,
            treeData: [],
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            pid: null,
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
        console.log('this.model', this.model)
        //获取所有的目录
        getFolders().then(res => { this.treeData = res.data.list || {} })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            data.ids = this.model.selectedIds
            console.log('提交的数据', data)

            this.loading = true
            zmTask(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.actionName + '成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showZmForm', false)
        },
    }
}
